import '../sass/latest-news.scss';

(() => {
    const swiperScript = document.querySelector('#ofg-schools-swiper-js');
    const $blocks = document.querySelectorAll('.block.latest-news');

    if (!$blocks) return;

    $blocks.forEach($block => {
        const $carousel = $block.querySelector('.latest-news__swiper');
        const $pagination = $block.querySelector('.latest-news__pagination');

        const initCarousels = () => {
            if (!$carousel)  return;

            new Swiper($carousel, {
                slidesPerView: 'auto',
                pagination: {
                    el: $pagination,
                    type: 'bullets',
                    clickable: true
                },
                spaceBetween: 30,
            });
        };

        if (typeof Swiper !== 'undefined') {
            initCarousels();
        } else if (swiperScript) {
            swiperScript.addEventListener('load', () => {
                initCarousels();
            });
        } else {
            window.addEventListener('load', () => {
                const swiperScript = document.querySelector('#ofg-schools-swiper-js');

                if (!swiperScript) return;

                initCarousels();
            });
        }
    });
})();
